module.exports = __webpack_public_path__ + "img/jo.17530dec.svg";